let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ait7e")).then(() => parcelRequire('ihMq7'));